import { useQuery } from '@tanstack/react-query';
import adminDispatchService from '../api/adminDispatchService';

const KEYS = {
    all: ['adminDispatches'],
    detail: (id) => ['adminDispatch', id]
};

export const useAdminDispatches = (params = {}) => {
    return useQuery({
        queryKey: [...KEYS.all, params],
        queryFn: () => adminDispatchService.getAll(params).then((res) => res.data),
        staleTime: 2 * 60 * 1000 // Logistics data should be relatively fresh
    });
};

export const useAdminDispatchDetail = (id) => {
    return useQuery({
        queryKey: KEYS.detail(id),
        queryFn: () => adminDispatchService.getById(id).then((res) => res.data),
        enabled: !!id,
        staleTime: 5 * 60 * 1000
    });
};
